import styled from 'styled-components';

export const PwdEditablePopupContainer = styled.div`
  width: 350px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  font-size: 15px;
  text-align: center;
  background: rgb(39,47,60);

  & > form > div {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin: 10px 0px;

    & > div {
      display: flex;
      justify-content: center;
      align-items: center;

      & > select:disabled {
        background: #333;
      }
    
      & > p {
        margin-bottom: 0.3rem;
        width: 130px;
        text-align: left;
      }
  
      & > input, & > select {
        width: 180px;
      }
    }

    & > div.error-box {
      font-size: 10px;
    }
  }

  & > button {
    color: #fff;
    font-size: 14px;
    background-color: #3d4a5c;
    border-width: 0px;
    padding: .4rem 2.4rem;
  }
`;